import React, { Component } from "react";
import { connect } from "react-redux";
import { GetAllCourseAction } from "store/Home";
import { ChevronLeft } from "react-feather";
import IlearnBanner from "views/ilearn/ilearndetails/components/IlearnBanner";
import BannerDetailsCard from "views/ilearn/ilearndetails/components/BannerDetailsCard";
import IlearnDeatilsTab from "views/ilearn/ilearndetails/components/IlearnDeatilsTab";
import IlearnSkillGain from "views/ilearn/ilearndetails/components/IlearnSkillGain";
import IlearnInstructors from "views/ilearn/ilearndetails/components/IlearnInstructors";
import IlearnEmployeeStory from "views/ilearn/ilearndetails/components/IlearnEmployeeStory";
import IlearnSimilarCourse from "views/ilearn/ilearndetails/components/IlearnSimilarCourse";
import FooterSection from "views/home/components/FooterSection.js";
import { GETCOURSEBYIDACTION } from "store/Ilearn";
import FileBase64 from "react-file-base64";
class IlearnDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      courses: [],
      description: "",
    };
  }

  async componentDidMount() {
    // let res =
    try {
      
  
    let payload = {
      CourseId: this.props.match.params.CourseId,
      ApplicantId: this.props.mgid,
    };
    let response = await this.props.getCoursesById(payload);
    // console.log(response.data.Data[0])
    if (response) {
      this.setState({ courses: response.Data[0] });
      this.setState({ description: response.Data[0].c_description });
      let descriptionID = document.querySelector("#coursedescription");
      descriptionID.innerHTML = decodeURIComponent(this.state.description);
    }
    // this.props.getCoursesById(payload).then((response)=>{
    //   console.log(response)
    //   this.setState({ courses: response.data.Data[0] })
    //   this.setState({description:response.data.Data[0].c_description})
    //   let descriptionID = document.querySelector('#coursedescription');
    //     descriptionID.innerHTML =  decodeURIComponent(this.state.description)
    // })
    // .catch((err) => {
    //   console.log(err)
    // })
  } catch (error) {
      
  }
  }

  render() {
    const CourseId = this.props.match.params.CourseId;
    // console.log(CourseId)
    return (
      <div className='mt-80px  lg:pt-6 md:pt-6'>
        <div className='lg:px-0 md:px-0 px-5'>
          <div className='mx-auto container'>
            <ul className='bradcrumb flex mob-hidden'>
              <li className='bradcrumb-li fsize14'>Home </li>&nbsp;/&nbsp;
              <li className='bradcrumb-li fsize14'> All Courses</li>{" "}
              &nbsp;/&nbsp;
              <li className='text-black fsize14 font-semibold'>
                {this.state.courses.c_title}
              </li>
            </ul>

            <div className='flex items-center mt-6'>
              <ChevronLeft />
              <h1 className='font-semibold fsize18 ml-2 text-black uppercase'></h1>
            </div>
            <div className='bottom-b-grey mt-3'></div>
          </div>
          <div className='mx-auto container'>
            <IlearnBanner Course={this.state.courses} />
          </div>
        </div>

        <div className='mx-auto container'>
          <BannerDetailsCard Course={this.state.courses} />
        </div>

        {/* <div className="mx-auto container">
          <IlearnDeatilsTab Course={this.state.courses}/>
        </div>

        <div className="mx-auto container">
          <IlearnSkillGain Course={this.state.courses}/>
        </div>

        <div className="mx-auto container">
          <IlearnInstructors Course={this.state.courses}/>
        </div>

        <div>
          <IlearnEmployeeStory Course={this.state.courses}/>
        </div> */}
        <div className='lg:px-0 md:px-0 px-5'>
          <div className='mx-auto container' id='coursedescription'></div>
        </div>
        <div className='lg:px-0 md:px-0 px-5'>
          <div className='mx-auto container py-12'>
            {this.state.courses ? (
              <IlearnSimilarCourse Course={this.state.courses} />
            ) : (
              <IlearnSimilarCourse />
            )}
            <div className='flex justify-center mt-12'>
              <button className='cust-viewall-btn flex'>VIEW ALL</button>
            </div>
          </div>
        </div>
        <div className='mt-6 footer-css'>
          <FooterSection Course={this.state.courses} />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    SINGLECOURSE: state.iLearn.course.SINGLECOURSE,
    mgid: state.Auth.user.MGID,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCoursesById: async (payload) =>
      await dispatch(GETCOURSEBYIDACTION(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(IlearnDetails);
